export const languageLSKey = 'locale'
export const LANGUAGE_CODES = {
  EN: 'en',
  FR: 'fr',
}
